import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DictationCopilotMeta } from '../../../_interfaces/dictation';
import {
  CollapsibleBoxClasses,
  CollapsibleBoxComponent,
} from '../collapsible-box/collapsible-box.component';
import {
  DetailsFieldsComponent,
  DetailsFieldsVariant,
} from '../details-fields/details-fields.component';

@Component({
  selector: 'app-details-sections',
  standalone: true,
  imports: [CollapsibleBoxComponent, DetailsFieldsComponent, TranslateModule],
  templateUrl: './copilot-details-sections.component.html',
})
export class CopilotDetailsSectionsComponent {
  @Input() variant: DetailsFieldsVariant = 'document';
  @Input({ required: true }) copilot!: DictationCopilotMeta;
  @Input({ required: true }) detailsBoxClasses!: CollapsibleBoxClasses;
  @Input() textClass = '';
  @Input() emptyClass = '';
  @Input({ required: true }) personalDetailsTestId!: string;
  @Input({ required: true }) visitDetailsTestId!: string;
}
